
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[category]/[document]",
      function () {
        return require("private-next-pages/[category]/[document].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[category]/[document]"])
      });
    }
  